
import './App.css';
import Weather from './components/Weather';
import Navbar from './components/Navbar';
function App() {
  return (
    <div>
    <Navbar/>
    <Weather/>
    </div>
  );
}

export default App;
